import CoreuiController from "../lib/coreui-controller"
import Carousel from "../coreui/carousel"

export default class CoreuiCarouselController extends CoreuiController {
  static Component = Carousel
}
